<template>
  <div class="stock-invoice-emails">
    <div class="d-flex align-center mb-2">
      <div class="subtitle-2">{{ $t("STOCK.INVOICES.EMAIL_HISTORY") }}</div>
      <v-chip v-if="reminderDue" small color="amber darken-2" dark class="ml-2">
        {{ $t("STOCK.INVOICES.REMINDER_DUE") }}
      </v-chip>
    </div>
    <p class="caption grey--text text--darken-1 mb-3">
      {{ $t("STOCK.INVOICES.EMAIL_HISTORY_HINT") }}
    </p>

    <div v-if="!sends.length" class="body-2 grey--text">
      {{ $t("STOCK.INVOICES.EMAIL_HISTORY_EMPTY") }}
    </div>

    <v-simple-table v-else dense>
      <thead>
        <tr>
          <th>{{ $t("STOCK.INVOICES.EMAIL_SENT_AT") }}</th>
          <th>{{ $t("STOCK.INVOICES.EMAIL_KIND") }}</th>
          <th>{{ $t("STOCK.INVOICES.EMAIL_RECIPIENTS") }}</th>
          <th>{{ $t("STOCK.INVOICES.EMAIL_NOTE") }}</th>
          <th>{{ $t("STOCK.INVOICES.PAYMENT_STATUS") }}</th>
          <th class="text-right"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="send in sends" :key="send.id">
          <td>{{ formatSentAt(send.sent_at) }}</td>
          <td>{{ kindLabel(send.kind) }}</td>
          <td>{{ recipientLabel(send) }}</td>
          <td class="stock-invoice-emails__note">{{ send.message_note || "—" }}</td>
          <td>{{ statusLabel(send.delivery_status) }}</td>
          <td class="text-right">
            <v-btn
              v-if="send.snapshot"
              text
              small
              color="teal darken-1"
              @click="$emit('download', send)"
            >
              <v-icon left small>mdi-download</v-icon>
              {{ $t("STOCK.INVOICES.EMAIL_DOWNLOAD_SNAPSHOT") }}
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "StockInvoiceEmailPanel",
  props: {
    sends: {
      type: Array,
      default: () => [],
    },
    reminderDue: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatSentAt(value) {
      if (!value) {
        return "—";
      }
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }
      return date.toLocaleString();
    },
    kindLabel(kind) {
      if (kind === "reminder") {
        return this.$t("STOCK.INVOICES.EMAIL_KIND_REMINDER");
      }
      return this.$t("STOCK.INVOICES.EMAIL_KIND_INVOICE");
    },
    recipientLabel(send) {
      const emails = (send.recipients || []).map((recipient) => recipient.email).filter(Boolean);
      return emails.length ? emails.join(", ") : "—";
    },
    statusLabel(status) {
      if (status === "simulated") {
        return this.$t("STOCK.INVOICES.EMAIL_STATUS_SIMULATED");
      }
      return status || "—";
    },
  },
};
</script>

<style scoped>
.stock-invoice-emails__note {
  white-space: pre-wrap;
  max-width: 280px;
}
</style>
